import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from '../../styles/constants';

export const tableResponsiveClassName = css({
  display: 'block',
  width: '100%',
  overflowX: 'auto',
});

export const tableClassName = css({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'auto',
});

export const tableHeadClassName = css({
  borderBottom: `1px solid ${Colors.LightGray}`,
  '& th': {
    color: Colors.Primary,
    fontSize: FontSize.REGULAR,
    fontWeight: FontWeight.SEMI_BOLD,
    padding: Spacing.LG,
    paddingTop: 0,
    '&:first-of-type': {
      padding: `${Spacing.LG}px ${Spacing.LG}px ${Spacing.LG}px 0`,
      paddingTop: 0,
    },
    whiteSpace: 'nowrap',
    [SMALL_DEVICE_MQ]: {
      fontSize: FontSize.COMPACT,
      fontWeight: FontWeight.BOLD,
      padding: Spacing.LG,
      '&:first-of-type': {
        padding: Spacing.LG,
      },
    },
  },
});

export const tableBodyClassName = css({
  textAlign: 'left',
  '& tr': {
    borderBottom: `1px solid ${Colors.LightGray}`,
    '&:last-of-type': {
      borderBottom: 0,
    },
  },
});

export const tableRowClassName = css({
  '& th, td': {
    color: Colors.Secondary,
    cursor: 'pointer',
    fontSize: FontSize.COMPACT,
    fontWeight: FontWeight.MEDIUM,
    padding: `calc(${Spacing.MD}px) ${Spacing.LG}px`,
    whiteSpace: 'nowrap',
  },
  '& th': {
    color: Colors.Primary,
    fontWeight: FontWeight.SEMI_BOLD,
    '&:first-of-type': {
      padding: `calc(${Spacing.MD}px) ${Spacing.LG}px calc(${Spacing.MD}px) 0`,
    },
    [SMALL_DEVICE_MQ]: {
      '&:first-of-type': {
        padding: `calc(${Spacing.MD}px) ${Spacing.LG}px calc(${Spacing.MD}px) ${Spacing.LG}px`,
      },
    },
  },
  [SMALL_DEVICE_MQ]: {
    '&:hover': {
      background: '#F8F8F8',
    },
  },
});
